import { useMediaQuery, useTheme } from '@material-ui/core';
export var useIsMobile = function () {
    var theme = useTheme();
    var isMobile = !useMediaQuery(theme.breakpoints.up('md'));
    return isMobile;
};
